import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
export const ProgressButtons = ({
  setProgress,
  next,
  back,
  disabled,
}: {
  setProgress?: (value: number) => void;
  next: number;
  back: number;
  disabled?: boolean;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const progressing = (e: React.MouseEvent) => {
    const { id, value } = e.target as HTMLInputElement;
    if(location?.state?.fromEventPage && value === String(back)){
      navigate(-1)
    }
    else if (id === "progress") {
      setProgress?.(Number(value));
    }
  };
  const { t } = useTranslation();
  return (
    <>
      <button
        onClick={progressing}
        value={next}
        id="progress"
        className="z2 primary"
        disabled={disabled}
      >
        {t("global.button.continue")}
      </button>
      <button className="z2" id="progress" value={back} onClick={progressing}>
        {t("global.button.back")}
      </button>
    </>
  );
};
